// Centralized dev-only console logger (single function).
// Uses a custom env var (CRA requires REACT_APP_ prefix).

const ENV_VALUE = (process.env.REACT_APP_ENV || "").toLowerCase();
const IS_PRODUCTION = ENV_VALUE === "production";

const safeConsole = typeof console !== "undefined" ? console : null;

/**
 * Usage: logger("log" | "error" | "warn" | "info" | "debug", ...args)
 * In production (REACT_APP_ENV=production) this becomes a no-op.
 */
export default function logger(level, ...args) {
  if (IS_PRODUCTION) return;
  if (!safeConsole) return;

  const method =
    level === "error" ||
    level === "warn" ||
    level === "info" ||
    level === "debug" ||
    level === "log"
      ? level
      : "log";

  const fn = safeConsole[method] || safeConsole.log;
  if (typeof fn !== "function") return;

  fn.apply(safeConsole, args);
}

